"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationsList = void 0;
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const react_1 = __importStar(require("react"));
const fuse_js_1 = __importDefault(require("fuse.js"));
const searchInput_1 = require("../searchInput");
const LocationsList = ({ locations, searchable = true, renderItem, threshold = 0.2, searchPlaceholder, title, }) => {
    const { translate } = (0, i18n_1.useI18n)();
    const [query, setQuery] = (0, react_1.useState)("");
    const deferredQuery = (0, react_1.useDeferredValue)(query);
    const fuseSearch = (0, react_1.useMemo)(() => new fuse_js_1.default(locations, {
        keys: ["query_text"],
        threshold,
    }), [threshold, locations]);
    const filteredLocations = (0, react_1.useMemo)(() => {
        if (deferredQuery.length < 1)
            return locations;
        return fuseSearch.search(deferredQuery).map(({ item }) => item);
    }, [deferredQuery, fuseSearch, locations]);
    return (react_1.default.createElement("main", { className: "locations-list" },
        searchable && (react_1.default.createElement("div", { className: "locations-list__search" },
            react_1.default.createElement(searchInput_1.SearchInput, { value: query, id: "main-search", onChange: setQuery, placeholder: searchPlaceholder }))),
        title && react_1.default.createElement("h2", { className: "locations-list__heading" }, title),
        filteredLocations.length === 0 && (react_1.default.createElement("div", null, translate("sections.locations_list.no_results", {
            query,
            example_location: locations[0].name,
        }))),
        react_1.default.createElement("ol", { className: "locations-list__list" }, filteredLocations.map((location) => (react_1.default.createElement(react_1.Fragment, { key: location.id }, renderItem(location)))))));
};
exports.LocationsList = LocationsList;
